import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

interface CheckStatusResponse {
  responseStatus?: {
    code: string
    message: string
  }
  responseObject?: any[]
}

const checkStatusResponseParser = (data: any): CheckStatusResponse => {
  console.log('[PG_DEBUG] Raw data received by Parser:', data)
  // --- 1. Use isStatusOK to check the outer wrapper ---
  if (isStatusOK(data)) {
    console.log(
      data?.data,
      'response parser checkStatusAPI API try block check what data we are sending to respponse parser data',
    )
    console.log('response parser checkStatusResponseParser API try block', data)
    const payload = data?.data // Extract the actual BBPS response
    const statusCode = payload?.responseStatus?.code

    // Handle Retryable Code 111
    // if (statusCode === '111' || statusCode === 'ERR0053') {
    //   throw { type: 'RETRYABLE_ERROR', code: '111', message: payload?.responseStatus?.message };
    // }

    // if (statusCode === 'ERR0086') {
    //     throw {
    //         type: 'BUSINESS_ERROR',
    //         code: statusCode,
    //         message: payload?.responseStatus?.message || 'Payment failed.',
    //         data: payload // Pass payload to show details on error screen
    //     }
    // }
    // If everything is fine, return the payload for the Lifecycle steps
    return payload
  } else {
    const networkError = getNetworkResponseError(data)

    // HTTP Codes that warrant a retry (Gateway issues)
    const retryableHttpCodes = [408, 429, 502, 503, 504]
    const isRetryable = retryableHttpCodes.includes(data?.httpCode)

    throw {
      type: isRetryable ? 'RETRYABLE_ERROR' : 'TERMINAL_ERROR',
      code: networkError.code,
      message: networkError.message,
    }
  }
}

export const checkStatusAPI = (tokens: any, requestBody: any) => {
  let config = sitConfig(tokens) as any
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || 'N/A'
  // config.headers['x-channel-user-id'] = RootStore.agent.agentInfo.agentUserLoginId || '1123766817865366323';
  config.headers['x-channel-user-id'] =
    RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || '1123766817865366323'
  config.headers['x-intercept-gateway'] = 'SERVICE/JPB'

  const request: Request<{}> = {
    apiPath: 'jpb/v2/dsp/order/checkStatus',
    method: 'POST',
    config: config,
    body: requestBody,
  }
  sendEventApi(tokens, request, { status: 'INITIATED' })

  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Check Status API checkStatus checkStatusResponseParser Raw Response')
      return checkStatusResponseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, { status: 'SUCCESS' })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, { status: 'FAILED', errorDescription: err })
      throw err
    })
}

// const checkStatusResponseParser = (data: any): CheckStatusResponse => {
//   console.log('[PARSER] Processing checkStatus data:', data);

//   // 1. Basic Validation: Handle null or HTML error pages from Gateway
//   if (!data || (typeof data === 'string' && data.includes('<html>'))) {
//     throw {
//       type: 'NETWORK_ERROR',
//       code: 500,
//       message: 'Server encountered an error. Please wait a moment.',
//     };
//   }

//   // 2. Extract internal data if wrapped in JFS standard network response
//   // Assuming isStatusOK checks for HTTP 200/Success at the root level
//   const payload = data?.data || data;
//   const statusCode = payload?.responseStatus?.code;
//   const responseObject = payload?.responseObject;

//   // 3. Handle System/Retryable Errors (Code 111 or 112)
//   if (statusCode === '111') {
//     throw {
//       type: 'RETRYABLE_ERROR',
//       code: statusCode,
//       message: payload?.responseStatus?.message || 'System busy, retrying...',
//     };
//   }

//   // 4. Handle Business Logic
//   if (Array.isArray(responseObject) && responseObject.length > 0) {
//     const orderData = responseObject[0]?.order;
//     const pStatus = orderData?.payment?.status;
//     const fStatus = orderData?.fulfilment?.status;

//     // SCENARIO: Payment Successful (Move to Step 4+)
//     if (pStatus === 'SUCCESS') {
//       return payload as CheckStatusResponse;
//     }

//     // SCENARIO: Payment Failed (Terminal Error)
//     if (pStatus === 'FAILED' || pStatus === 'FAILURE' || statusCode === 'ERR0086') {
//       throw {
//         type: 'BUSINESS_ERROR',
//         code: statusCode,
//         message: payload?.responseStatus?.message || 'Payment failed.',
//         data: payload, // Pass data back to show in error screen
//       };
//     }

//     // SCENARIO: Pending/Processing (ERR0053 or PENDING status)
//     if (pStatus === 'PENDING' || statusCode === 'ERR0053') {
//       return payload as CheckStatusResponse; // Let startPolling continue
//     }
//   }

//   // 5. Fallback for undefined states
//   return payload;
// };

// interface CheckStatusResponse {
//   responseStatus?: {
//     code: string;
//     message: string;
//   };
//   responseObject?: any[];
// }

// const checkStatusResponseParser = (data: any): CheckStatusResponse => {
//   console.log('[PARSER] Processing checkStatus data:', data);
//   if (!data || (typeof data === 'string' && data.includes('<html>'))) {
//     throw {
//       type: 'NETWORK_ERROR',
//       code: 500,
//       message: 'Server encountered an error. Please wait a moment.',
//     };
//   }

//   // --- 1. HANDLE ROOT-LEVEL ERROR OBJECT (e.g., Code 111) ---
//   if (data?.error) {
//     const errCode = String(data.error.code);
//     const errMsg = data.error.message || 'System is temporarily busy';

//     if (errCode === '111') {
//       // We throw a specific type so the component knows to keep polling
//       throw {
//         type: 'RETRYABLE_ERROR',
//         code: errCode,
//         message: errMsg,
//       };
//     }

//     // Other root-level errors are treated as terminal
//     throw {
//       type: 'TERMINAL_ERROR',
//       code: errCode,
//       message: errMsg,
//     };
//   }

//   // --- 2. HANDLE STANDARD JFS NETWORK WRAPPER ---
//   if (isStatusOK(data) && (data?.errorCode === 0 || data?.status === 'SUCCESS')) {
//     const responseData = data?.data;
//     const statusCode = responseData?.responseStatus?.code;

//     // SCENARIO: Success (000) OR Payment In Process (ERR0053)
//     // We return these so the polling logic can read the status
//     if (['000', 'ERR0053'].includes(statusCode) && Array.isArray(responseData.responseObject)) {
//       return responseData as CheckStatusResponse;
//     }

//     // SCENARIO: Business Logic Errors (e.g., Invalid Order, Expired)
//     else if (responseData?.responseStatus) {
//       console.error('[PARSER] Business Error:', responseData.responseStatus);
//       throw {
//         type: 'BUSINESS_ERROR',
//         code: statusCode,
//         message: responseData.responseStatus.message || 'Transaction could not be verified.',
//       };
//     }

//     // FALLBACK: Unexpected Success Format
//     else {
//       return responseData || ({} as CheckStatusResponse);
//     }
//   }

//   // --- 3. HANDLE NETWORK/GATEWAY FAILURES ---
//   else {
//     const networkError = getNetworkResponseError(data?.data);
//     throw {
//       type: 'NETWORK_ERROR',
//       code: data?.errorCode || -1,
//       message: networkError?.message || data?.message || 'Gateway connection failed.',
//     };
//   }
// };
// const checkStatusResponseParser = (data: any): CheckStatusResponse => {

//   if (data?.error) {
//     const errCode = data.error.code;
//     const errMsg = data.error.message;

//     // Logic: 111 usually means a temporary system glitch/throttle.
//     // We treat this as a NETWORK_ERROR so the UI stays on the "Processing" screen and retries.
//     if (errCode === "111") {
//       throw {
//         type: 'RETRYABLE_ERROR',
//         code: errCode,
//         message: errMsg
//       };
//     }
//     throw {
//       type: 'BUSINESS_ERROR',
//       code: errCode,
//       message: errMsg
//     };
//   }

//   if (isStatusOK(data) && (data?.errorCode === 0 || data?.status === 'SUCCESS')) {
//     const responseData = data?.data
//     const statusCode = responseData?.responseStatus?.code

//     // 1. Success OR Payment In Process (Polling required)
//     // We allow ERR0053 to pass through as a valid response so the UI can see "PENDING"
//     if ((statusCode === '000' || statusCode === 'ERR0053') && Array.isArray(responseData.responseObject)) {
//       return responseData as CheckStatusResponse
//     }

//     // 2. Actual Application Errors (e.g., Validation failed, Invalid ID)
//     else if (responseData?.responseStatus) {
//       console.error('Check Status API Application Error:', responseData.responseStatus)
//       throw getNetworkResponseError(responseData)
//     }

//     // 3. Fallback for unexpected formats
//     else {
//       return responseData || ({} as CheckStatusResponse)
//     }
//   } else {
//     // 4. Network or Gateway level errors
//     throw (
//       getNetworkResponseError(data?.data) || {
//         code: data?.errorCode || -1,
//         message: data?.message || 'An unexpected error occurred during status check.',
//       }
//     )
//   }
// }

// const checkStatusResponseParser = (data: any): CheckStatusResponse => {
//   if (isStatusOK(data) && (data?.errorCode === 0 || data?.status === 'SUCCESS')) {
//     const responseData = data?.data
//     if (responseData?.responseStatus?.code === '000' && Array.isArray(responseData.responseObject)) {
//       return responseData as CheckStatusResponse
//     } else if (responseData?.responseStatus) {
//       console.error('Check Status API Application Error:', responseData.responseStatus)
//       throw getNetworkResponseError(responseData)
//     } else {
//       console.error('API SUCCESS, but UNHANDLED PAYLOAD FORMAT. Raw Data:', data)
//       return responseData || ({} as CheckStatusResponse)
//     }
//   } else {
//     console.error('Check Status API Response Failed Parsing:', data)
//     throw (
//       getNetworkResponseError(data?.data) || {
//         code: data?.errorCode || -1,
//         message: data?.message || 'An unexpected error occurred during status check.',
//       }
//     )
//   }
// }
